module.exports = __webpack_public_path__ + "static/media/header-entries.f28eef09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/entries/header-entries.jpg
// module id = 671
// module chunks = 0